module.exports = __webpack_public_path__ + "static/media/bd-eBook-7-keys-to-unlock-medication-inventory-optimization.6c7456d6.pdf";